import { createSlice } from "@reduxjs/toolkit";

// Define the initial state for the slice
const initialState = {
  selectedServiceCenter: null,
  selectedServiceCenters: [],
};

// Create the InventoryServiceCenterSlice using createSlice
const InventoryServiceCenterSlice = createSlice({
  name: "inventoryServiceCenter",
  initialState,
  reducers: {
    // Handler for setting service center selection
    setServiceCenterSelection: (state, action) => {
      state.selectedServiceCenter = action.payload.selectedServiceCenter;
      state.selectedServiceCenters = action.payload.selectedServiceCenters;
    },
    // Handler for clearing service center selection
    clearServiceCenterSelection: (state) => {
      state.selectedServiceCenter = null;
      state.selectedServiceCenters = [];
    },
  },
});

// Export the actions
export const { setServiceCenterSelection, clearServiceCenterSelection } =
  InventoryServiceCenterSlice.actions;
export default InventoryServiceCenterSlice;
